'use client';
/** @jsxImportSource @emotion/react */

import type { TimelineProps } from '@mui/lab/Timeline';

import MuiTimeline from '@mui/lab/Timeline';

export type { TimelineProps };

// MUI types Timeline as ForwardRefExoticComponent, not a plain function like the
// other sub-components. This makes it incompatible with React.FC, so we use type
// inference here instead to preserve the original ref-forwarding type.
export const Timeline = MuiTimeline;

Timeline.displayName = 'Timeline';
